import { ROLE_ADMIN, ROLE_PARTNER_ADMIN, ROLE_SUPERADMIN } from "../../constants/roles";
import { createHasVendorAccessSelector } from "../session";

export const selectCanAccessVendorManagement = createHasVendorAccessSelector([ROLE_SUPERADMIN]);
